import { notification } from 'antd';
import { t } from 'i18next';
import React from 'react';
import useLongPress from '../../hooks/useLongPress';
import { CopyOutlined } from '@ant-design/icons';
import styles from './styles.module.css';

type TextCopyProps = {
    style?: React.CSSProperties;
    children?: string;
    text?: string;
    isPrimaryColor?: boolean;
    label?: string;
    disabled?: boolean;
    canWrapperClick?: boolean;
    wrapperStyle?: React.CSSProperties;
};

/**
 * 長押しすればクリップボードにコピーされるspan領域
 * @param {string} children
 * @returns
 */
const TextCopy = ({
    style,
    children,
    text,
    isPrimaryColor,
    label,
    disabled,
    canWrapperClick,
    wrapperStyle,
}: TextCopyProps) => {
    const onCopyText = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (disabled) {
            return;
        }
        event.stopPropagation();
        try {
            await global.navigator.clipboard.writeText(text ?? children ?? '');
            notification.success({
                description: t('notification.copy-success'),
                message: '',
            });
        } catch (error) {
            console.error(error);
        }
    };

    const longPressEvent = useLongPress(onCopyText, 1000);

    return (
        <div
            className={`${styles.wrapper} ${disabled ? styles.disabled : ''}`}
            style={{ ...wrapperStyle }}
            onClick={canWrapperClick ? (e) => void onCopyText(e) : undefined}
        >
            {!label && (
                <span style={{ ...style, cursor: 'pointer' }} {...longPressEvent}>
                    {children}
                </span>
            )}
            <CopyOutlined
                className={`${styles.copyIcon} ${isPrimaryColor ? styles.primary : ''} ${
                    disabled ? styles.disabled : ''
                }`}
                onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void onCopyText(e)}
            />
            {label && <span>{label}</span>}
        </div>
    );
};
export default TextCopy;
